import { render, staticRenderFns } from "./Pruksa.vue?vue&type=template&id=d538b87e&scoped=true"
import script from "./Pruksa.vue?vue&type=script&lang=js"
export * from "./Pruksa.vue?vue&type=script&lang=js"
import style0 from "./Pruksa.vue?vue&type=style&index=0&id=d538b87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d538b87e",
  null
  
)

export default component.exports